export const FeedbackMessageHandler = {
  getFeedbackMessage(context) {
    return context.$store.getters.feedbackMessage;
  },
  getIsSuccess(context) {
    return context.$store.getters.isSuccess;
  },
  setFeedbackMessage(context, message) {
    context.$store.commit('SET_FEEDBACK_MESSAGE', message);
  },
  setIsSuccess(context, isSuccess) {
    context.$store.commit('SET_IS_SUCCESS_MESSAGE', isSuccess);
  },
  resetFeedbackMessage(context) {
    context.$store.commit('SET_FEEDBACK_MESSAGE', '');
  }
};

const state = {
  isSuccessMessage: true,
  message: ''
};

const getters = {
  feedbackMessage: (state) => {
    return state.message;
  },
  isSuccess: (state) => {
    return state.isSuccessMessage;
  }
};

const mutations = {
  SET_IS_SUCCESS_MESSAGE: (state, isSuccessMessage) => {
    state.isSuccessMessage = isSuccessMessage;
  },
  SET_FEEDBACK_MESSAGE: (state, message) => {
    state.message = message;
  }
};

export default {
  state,
  getters,
  mutations
};
